import { render, staticRenderFns } from "./food-search.vue?vue&type=template&id=dbd632f6&"
import script from "./food-search.vue?vue&type=script&lang=js&"
export * from "./food-search.vue?vue&type=script&lang=js&"
import style0 from "./food-search.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports